import { SelectionType } from 'app/shared/selection/SelectionType';

interface Attributes {
    positions: Cesium.Cartesian3[];
    color: Cesium.Color;
    id: string | number;
    allowPicking: boolean;
}

export function generatePolygonGroundPrimitiveOptions({
    positions,
    color,
    id,
    allowPicking,
}: Attributes): Partial<Cesium.GroundPrimitive> {
    const polygonGeometry = Cesium.PolygonGeometry.fromPositions({
        positions,
        extrudedHeight: undefined, // no extrusion
        height: 0, // no height - shouldn't matter, we'll use a ground primitive to display this geometry anyway
        vertexFormat: Cesium.PerInstanceColorAppearance.VERTEX_FORMAT,
        perPositionHeight: false, // the positions array shouldn't need a height value (it's just latitude and longitude)
    });

    const geometryInstance = new Cesium.GeometryInstance({
        geometry: polygonGeometry,
        attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(color),
        },
        id: {
            getId: () => id,
            id,
            selectionType: SelectionType.ENTITY,
        },
    });

    return {
        // please store the geometry instance for us - we'll grab it later to update the color
        releaseGeometryInstances: false,
        geometryInstances: geometryInstance,
        // use the color attribute of the geometry - which we can update
        appearance: new Cesium.PerInstanceColorAppearance({
            closed: true,
            translucent: true,
        }),
        show: true,
        asynchronous: false,
        allowPicking,
    };
}
